import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=00cf7f5e"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports